import React from 'react';
import { Box } from '@mui/material';
import CompatibilityManagement from '../../components/admin/CompatibilityManagement';

/**
 * Compatibility Manager Tab
 *
 * Integrates the existing Compatibility Management feature into the Taxonomy Hub.
 * This feature allows defining explicit compatibility rules for accessories, bundles, and upsells.
 *
 * The CompatibilityManagement component is already fully implemented and production-ready.
 * It supports:
 * - Machine compatibility (portafilter size, group head size)
 * - Grinder compatibility (burr diameter)
 * - Dripper compatibility (model-specific)
 * - Exclusive rules (only appears with specific equipment)
 * - Smart suggestions based on product attributes
 */
export default function CompatibilityManagerTab() {
  return (
    <Box>
      {/*
        Render the existing CompatibilityManagement component as-is.
        No modifications needed - it's already a self-contained, working feature.
      */}
      <CompatibilityManagement />
    </Box>
  );
}
